import { render, staticRenderFns } from "./GiftCardSelector.vue?vue&type=template&id=e0b12f3a"
import script from "./GiftCardSelector.vue?vue&type=script&lang=js"
export * from "./GiftCardSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports